import { NavItemBaseProps } from 'src/layouts/main/nav/types';

export const navConfig: NavItemBaseProps[] = [
  { title: 'Product', path: '#chat' },
  { title: 'Experience', path: '#experience' },
  { title: 'Setup', path: '#setup' },
  { title: 'APIs', path: '#predefined-apis' },
  { title: 'Features', path: '#features' },
];
